import { IUser } from "services/types";
import { useUserStore } from "store/userStore";

export interface CurrentUserObject extends IUser {
}

// eslint-disable-next-line no-redeclare
export class CurrentUserObject {
  readonly CONTENT_MANAGER_ROLE = "content manager";

  constructor(src: IUser) {
    Object.assign(this, src, {});
  }

  getRoles(): string[] {
    return this.roles ?? [];
  }

  hasRole(role: string): boolean {
    if (!this.roles) {
      return false;
    }

    return this.roles.indexOf(role) >= 0;
  }

  isContentManager(): boolean {
    return this.hasRole(this.CONTENT_MANAGER_ROLE);
  }
}

export const useVisitorInfo = (): CurrentUserObject|null => {
  const currentUser = useUserStore((state) => state.currentUser);
  const isUserExist = currentUser && !!Object.entries(currentUser).length;

  if (!isUserExist) {
    return null;
  }

  return new CurrentUserObject(currentUser);
};
